module.exports = __webpack_public_path__ + "static/media/creditCardLeftSideIcon.4c98d8db.svg";